import React, { PropTypes } from 'react'

import Price from 'components/Price'
import PaintSwatch from 'components/PaintSwatch'
import StampSwatch from 'components/StampSwatch'
import classNames from 'classnames'

const StampSummary = ({ stamps }) => (
  <div className="customize-form-section">
    <div className="customize-form-section-header">
      Stamps
      <Price value={stamps.reduce((t, s) => (t + (!!s.selected && s.selected.stamp.price) || 0), 0)} />
    </div>
      <div className="customize-form-section-content">
        <div className="stamp-summary">
          {
            stamps.map(stamp => (
              <div key={stamp.loc.id}>
                <div className="paintfill-chooser">
                  <div className="paintfill-selection">
                    {stamp.loc.label}
                    {stamp.selected &&
                      <StampSwatch stamp={stamp.selected.stamp} selected={false}/>
                    }
                  </div>
                </div>
                <div className={classNames("paintfill-chooser", { "error" : stamp.selected != undefined && stamp.selected.enabled && !stamp.paint.valid })}>
                  <div className="paintfill-selection">
                    {stamp.paint.loc.label}
                    <PaintSwatch paint={stamp.paint.selected} />
                  </div>
                </div>
              </div>
            ))
          }
        </div>
      </div>
  </div>
)

StampSummary.propTypes = {
  stamps: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default StampSummary